export const InfoIcon = ({ fill = 'white', width = '73', height = '73' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 73 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="73" height="73" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.5 66.9167C19.7009 66.9167 6.08331 53.2992 6.08331 36.5C6.08331 19.7009 19.7009 6.08337 36.5 6.08337C53.2991 6.08337 66.9166 19.7009 66.9166 36.5C66.9166 53.2992 53.2991 66.9167 36.5 66.9167ZM39.5416 24.3334C39.5416 26.0132 38.1798 27.375 36.5 27.375C34.8201 27.375 33.4583 26.0132 33.4583 24.3334C33.4583 22.6535 34.8201 21.2917 36.5 21.2917C38.1798 21.2917 39.5416 22.6535 39.5416 24.3334ZM36.5 30.4167C38.1798 30.4167 39.5416 31.7785 39.5416 33.4584V48.6667C39.5416 50.3466 38.1798 51.7084 36.5 51.7084C34.8201 51.7084 33.4583 50.3466 33.4583 48.6667V33.4584C33.4583 31.7785 34.8201 30.4167 36.5 30.4167Z"
      fill={fill}
    />
  </svg>
);
